import pdfMake from 'pdfmake/build/pdfmake';
import 'pdfmake/build/vfs_fonts';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import tinycolor from 'tinycolor2';
import { clone, getAvailableCandidatesForRow } from '../../schedule';
import Swal from 'sweetalert2';
import { openPdfInNewTabOrAlert } from '../../pdfOpen';
import profilePlaceholder from '../CandidateBadges/Portrait_Placeholder.png';
import rezRateLogo from '../rezRateLogo.png';
import { imageToBase64 } from 'Common.functions';

dayjs.extend(utc);
dayjs.extend(timezone);

let rezRateLogoBase64 = null;
// const bgGuide = require('./AVERY_5390.png');
let profilePlaceholderBase64 = null;

// 1 inch = 72 units.
// LETTER size is 612x792

const tableLayouts = {
  customTable: {
    hLineWidth: (i, node) => {
      return 1;
      // if (i === 0 || i === node.table.body.length) {
      //   return 0;
      // }
      // return i === node.table.headerRows ? 2 : 1;
    },
    vLineWidth: (i) => {
      return 1;
    },
    hLineColor: (i) => {
      return i === 1 ? 'black' : '#aaa';
    },
    paddingLeft: (i) => {
      return 0;
    },
    paddingRight: (i, node) => {
      return 0;
    },
    paddingTop: (i, node) => {
      return 0;
    },
    paddingBottom: (i, node) => {
      return 0;
    },
  },
};

const createPDFProper2 = (data) => {
  const { interviewDate, candidates, department, departmentLogo, scheduleData, rowTracker, columnTracker } = data;
  const { body = [], headers = [], metaData = {} } = scheduleData;

  const candidateKeys = candidates.map((c) => {
    return c.pk_Candidate;
  });

  const columnsToFill = headers.map((h) => {
    return h.pk_ScheduleAssignment;
  });

  const interviewCountTracker = {};
  Object.keys(rowTracker).forEach((r) => {
    candidateKeys.forEach((c) => {
      if (rowTracker[r].includes(c)) {
        if (interviewCountTracker[c] != null) {
          interviewCountTracker[c] += 1;
        } else {
          interviewCountTracker[c] = 1;
        }
      }
    });
  });

  const tableRows = [];
  let rows = [
    [
      { text: 'Time Slot', style: { fontSize: 15, alignment: 'center', bold: true } },
      { text: 'Candidates on Break', fontSize: 15, alignment: 'center', bold: true },
    ],
  ];

  const renderCard = (candidates, timeSlotRow) => {
    const cardRows = [];
    const userDetailRows = [];
    const rowColumns = [];

    rowColumns.push({
      style: { alignment: 'center', bold: true },
      text: `${dayjs(timeSlotRow.slot)
        .tz(department.TimeZone)
        .format('hh:mm A')} `,
      fontSize: 11,
      margin: [0, 0, 0, 2],
    });
    candidates.forEach((candidate) => {
      const { userPhotoBase64 } = candidate;
      const userPhoto = userPhotoBase64
        ? {
            width: 40,
            columns: [
              {
                image: userPhotoBase64 ? `data:image/png;base64,${userPhotoBase64}` : null,
                fit: [20, 20],
              },
            ],
            margin: [10, 0, 10, 0],
          }
        : {
            width: 40,
            columns: [
              {
                image: profilePlaceholderBase64 ? `data:image/png;base64,${profilePlaceholderBase64}` : null,
                fit: [20, 20],
              },
            ],
            margin: [10, 0, 10, 0],
          };

      userDetailRows.push({
        style: { alignment: 'left', paddingLeft: 50 },
        text: `${candidate.LastName}, ${candidate.FirstName} `,
        fontSize: 10,
        margin: [15, 0, 0, 0],
      });
    });

    if (candidates.length <= 0) {
      userDetailRows.push({
        style: { alignment: 'left', paddingLeft: 50 },
        text: `No Candidates on Break! `,
        fontSize: 10,
        margin: [15, 0, 0, 0],
      });
    }

    rowColumns.push({ columns: [userDetailRows], style: { paddingTop: 10, paddingBottom: 10 } });

    cardRows.push(rowColumns);

    return rowColumns;
  };

  body.forEach((timeSlotRow, i) => {
    if (timeSlotRow.pk_Timeslot === 'END') {
      return;
    }
    const currentRowToFill = rowTracker[timeSlotRow.pk_Timeslot];

    const validCandidatesActual = candidates.filter((c) => {
      return !currentRowToFill.includes(parseInt(c.pk_Candidate));
    });

    rows.push(renderCard(validCandidatesActual, timeSlotRow));
  });

  if (rows.length <= 0) {
    Swal.fire('Error', 'There are no Timeslots for this Interview Date. There is nothing to print!', 'error');
    return;
  }

  let pdfObject = [
    {
      table: { headerHeight: 50, widths: [1.95 * 72, 5.95 * 72], body: rows, dontBreakRows: true, headerRows: 1 },
      layout: 'customTable',
      margin: [10, 20, 0, 0],
    },
  ];

  // imageToBase64(bgGuide)
  //   .then((bgBase64) => {
  const docDefinition = {
    // background: { image: `data:image/png;base64,${bgBase64}`, width: 612 },
    info: { title: 'Candidates Break Report' },
    pageSize: 'LETTER',
    pageOrientation: 'portrait',
    content: pdfObject,
    defaultStyle: {
      fontSize: 10,
    },
    pageMargins: [0.25 * 72, 1.5 * 72, 0.25 * 72, 0.5 * 72],
    header: function(currentPage, pageCount, pageSize) {
      const deptLogo = {
        width: 80,
        columns: [
          {
            image: `data:image/png;base64,${departmentLogo || rezRateLogoBase64}`,
            // width: 90,
            fit: [80, 80],
          },
        ],
        margin: [0, 0, 10, 0],
      };

      const { DateOfInterview, StartTime, Label } = metaData || {};
      const dateToDisplay = interviewDate.MomentDateOfInterview
        ? interviewDate.MomentDateOfInterview.format('dddd, MMMM DD, YYYY')
        : DateOfInterview
        ? dayjs.tz(`${DateOfInterview} ${StartTime}`, department.TimeZone).format('dddd, MMMM DD, YYYY')
        : '(No Date)';

      return [
        {
          columns: [
            deptLogo,
            [
              [
                {
                  text: `Candidate Breaks Report - ${dateToDisplay}`,
                  alignment: 'bottom',
                  style: { bold: true },
                  fontSize: 15,
                  margin: [10, 0, 0, 0],
                },
              ],
              [
                {
                  text: ` ${interviewDate.Label ? interviewDate.Label : Label ? Label : ''}`,
                  alignment: 'bottom',
                  style: { bold: true, color: '#9e9e9e' },
                  fontSize: 12,
                  margin: [10, 0, 0, 0],
                },
              ],
              [
                {
                  text: `${department.DepartmentName}`,
                  alignment: 'bottom',
                  style: { bold: false },
                  fontSize: 11,
                  margin: [10, 0, 0, 0],
                },
              ],
              [
                {
                  text: `${department.OrganizationName || department.OrganizationAlias || ''}`,
                  alignment: 'bottom',
                  style: { bold: false },
                  fontSize: 11,
                  margin: [10, 0, 0, 0],
                },
              ],
            ],
          ],
          margin: [0.4 * 72, 20, 0.4 * 72, 0],
        },
      ];
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(docDefinition, tableLayouts);
  openPdfInNewTabOrAlert({
    pdfDocGenerator,
    downloadTitle: 'Candidate_Break_Report',
    previewCallback: data.previewCallback,
  });
  // })
  // .catch((err) => {
  // });
};

export const createPDFForCandidatesBreakReport = ({
  interviewDate,
  department,
  candidates = [],
  rowTracker,
  columnTracker,
  callback,
  scheduleData,
  previewCallback,
}) => {
  const candidatesCopy = clone(candidates);
  Promise.all([
    ...candidatesCopy.map((c) => {
      return new Promise((resolve, reject) => {
        if (c.PhotoUrl) {
          imageToBase64({
            url: c.PhotoUrl,
            callback: (err, base64Img) => {
              if (err) {
                resolve({ error: true, ...c });
                return;
              }
              c.userPhotoBase64 = base64Img;
              resolve(c);
            },
          });
        } else {
          resolve(c);
        }
      });
    }),
    new Promise((resolve, reject) => {
      imageToBase64({
        url: profilePlaceholder,
        callback: (err, base64) => {
          if (err) {
            reject(err);
            return;
          }
          profilePlaceholderBase64 = base64;
          resolve(base64);
        },
      });
    }),

    new Promise((resolve, reject) => {
      imageToBase64({
        url: rezRateLogo,
        callback: (err, res) => {
          if (err) {
            reject(err);
            return;
          }
          rezRateLogoBase64 = res;
          resolve(res);
        },
      });
    }),
  ])
    .then((res) => {
      if (department.DepartmentLogo) {
        imageToBase64({
          url: department.DepartmentLogo,
          callback: (err, deptLogo) => {
            if (err) {
              console.log('Error loading department logo: ', err);
              deptLogo = null;
            }
            if (!previewCallback && callback) {
              callback();
            }
            createPDFProper2({
              candidates: candidatesCopy,
              department,
              interviewDate,
              rowTracker,
              columnTracker,
              scheduleData,
              departmentLogo: deptLogo,
              previewCallback,
            });
          },
        });
      } else {
        createPDFProper2({
          candidates: candidatesCopy,
          department,
          interviewDate,
          rowTracker,
          columnTracker,
          scheduleData,
          previewCallback,
        });

        if (!previewCallback && callback) {
          callback();
        }
      }
    })
    .catch((err) => {
      console.log('err2: ', err);
      createPDFProper2({
        candidates: candidatesCopy,
        department,
        interviewDate,
        rowTracker,
        columnTracker,
        scheduleData,
        previewCallback,
      });
      if (previewCallback) {
        previewCallback(null, null, err);
      } else if (callback) {
        callback(err);
      }
    });
};
